module.exports = __webpack_public_path__ + "static/media/faq-hero.41f9066b.jpg";